'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useRouter } from 'next/navigation';
import { useAppSelector } from '@/store/hooks';
import { AdminLayoutInner } from './AdminLayoutInner';
interface AdminLayoutProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  className?: string;
}
const AdminGuard: React.FC<{
  children: React.ReactNode;
}> = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  const router = useRouter();
  const {
    user,
    isAuthenticated
  } = useAppSelector(_temp);
  const isLoading = useAppSelector(_temp2);
  if (isLoading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="flex h-screen w-full items-center justify-center"><div className="border-t-brand-600 h-8 w-8 animate-spin rounded-full border-4 border-neutral-200" /></div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (!isAuthenticated || !user) {
    router.replace("/login");
    return null;
  }
  if (user.tipoUsuario !== "ADMIN" && user.tipoUsuario !== "SECRETARIA") {
    router.replace("/");
    return null;
  }
  let t1;
  if ($[1] !== children) {
    t1 = <>{children}</>;
    $[1] = children;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
const AdminLayoutRoot = React.forwardRef<HTMLDivElement, AdminLayoutProps>(function AdminLayoutRoot(t0, ref) {
  const $ = _c(9);
  let children;
  let className;
  let otherProps;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = otherProps;
  } else {
    children = $[1];
    className = $[2];
    otherProps = $[3];
  }
  let t1;
  if ($[4] !== children || $[5] !== className || $[6] !== otherProps || $[7] !== ref) {
    t1 = <AdminGuard><AdminLayoutInner className={className} ref={ref} {...otherProps}>{children}</AdminLayoutInner></AdminGuard>;
    $[4] = children;
    $[5] = className;
    $[6] = otherProps;
    $[7] = ref;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
});
export const AdminLayout = AdminLayoutRoot;
function _temp(state) {
  return state.auth;
}
function _temp2(state_0) {
  return state_0.auth.isLoading;
}